<template>
  <main>
    <div class="container-fluid px-4">
      <h3 class="mt-4">CÁTALOGOS</h3>
      <ol class="breadcrumb mb-4">
        <li class="breadcrumb-item active"></li>
      </ol>
      <div class="row">
        <div class="col-xl-12">
          <div class="card mb-4">
            <div class="card-header">
              <i class="fas fa-book"></i>
              <span> CÁTALOGOS</span>
              <button
                class="btn btn-primary"
                style="float: right"
                @click="language = !language"
              >
                {{ language ? "ESP" : "ENG" }}
              </button>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  v-for="catalog in (language ? catalogs.english : catalogs.spanish)"
                  :key="catalog.url"
                  class="col-md-4 p-2 text-center"
                >
                  <a :href="catalog.url" target="_blank">
                    <img
                      class="img-fluid border border-1"
                      :src="catalog.image"
                      :alt="catalog.title"
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import constructionCatalog from '@/assets/img/catalogs/construction-catalog.webp';
import energyCatalog from '@/assets/img/catalogs/energy-catalog.webp';
import projectsCatalog from '@/assets/img/catalogs/projects-catalog.webp';
import englishConstructionCatalog from '@/assets/img/catalogs/english-construction-catalog.webp';
import englishEnergyCatalog from '@/assets/img/catalogs/english-energy-catalog.webp';
  
export default {
  data() {
    return {
      language: false,
      catalogs: {
        spanish: [
          {
            title: 'Catálogo material de Construcción',
            image: constructionCatalog,
            url: 'https://iusa.com.mx/catalogo_construccion/',
          },
          {
            title: 'Catálogo Energía',
            image: energyCatalog,
            url: 'https://iusa.com.mx/catalogo_energia/',
          },
          {
            title: 'Catálogo Proyectos',
            image: projectsCatalog,
            url: 'https://iusa.com.mx/catalogos/',
          },
        ],
        english: [
          {
            title: 'Construction Catalog',
            image: englishConstructionCatalog,
            url: 'https://eng.iusa.com.mx/construction_catalog/',
          },
          {
            title: 'Energy Catalog',
            image: englishEnergyCatalog,
            url: 'https://eng.iusa.com.mx/energy_catalog/',
          },
        ],
      },
    };
  },
};
</script>
